/**
 * Services
 */
import getApiUrl from "services/getApiUrl";
import { activityAPI, formActivityAPI } from "../../services/actions/activity";
/**
 * Todas atividades de Formulários
 */
export const allActivitiesForms = async ({ form = null, action = null, entity = null, createdBy = null, createdAt = null, page = 1, pageSize = 10, sorter = null, companyId = null, unitId = null }) => {
  // antd v6/pro v3: o sorter pode vir com entradas de valor null (coluna sem
  // ordenação ativa); remove antes de enviar ao backend
  const cleanSorter = sorter
    ? Object.fromEntries(Object.entries(sorter).filter(([, v]) => v))
    : null;
  return await formActivityAPI
    .search({
      companyId,
      unitId,
      form,
      action,
      entity,
      createdBy,
      createdAt,
      page,
      pageSize,
      sorter: cleanSorter && Object.keys(cleanSorter).length > 0 ? cleanSorter : null
    })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.error(
        "allActivitiesForms falhou:",
        err?.response?.status,
        err?.response?.data || err?.message
      );
      // Shape seguro p/ a tabela não quebrar quando a busca falha
      return {
        success: false,
        message: [],
        pagination: { totalHits: 0, totalPages: 0, currentPage: page, pageSize },
      };
    });
};

/**
 * Reverter atividade
 * @param {*} objects
 * @returns
 */
export const revertActivity = async (objects) => {
  const {
    formName,
    activitieId,
    page,
    action,
    ids,
    useBin,
    useActivitie,
    isImport,
    isObjDataUpdate,
    isObjDataRecover,
    createdBy,
  } = objects;
  return await getApiUrl
    .post(`/atividades/reverter?device=web&network=online`, {
      formName,
      activitieId,
      page,
      action,
      ids,
      useBin,
      useActivitie,
      isImport,
      isObjDataUpdate,
      isObjDataRecover,
      createdBy,
    })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      return err;
    });
};

/**
 * Reverter flag da atividade
 * @param {string} id
 * @returns
 */
export const revertActivityFlag = async (id) => {
  try {
    const [activityServiceRes] = await Promise.all([
      activityAPI.revertFlag(id)
    ]);

    return {
      success: true,
      activityService: activityServiceRes.data
    };
  } catch (err) {
    return {
      success: false,
      error: err.response?.data || err.message
    };
  }
};
